/* eslint-disable import/first */
import React from 'react';
import format from 'date-fns/format';
import { useNavigate } from '@reach/router';
import { Grid, Divider, Typography, Button } from '@material-ui/core';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;

const { selectCountryValidations } = Slices.configSlice;
// import { selectFirstMenu } = Slices.menuSlice;
// import { getOrder } = Slices.orderSlice;
// import { sendCart } = Slices.cartSlice;
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { useIntl, FormattedMessage } from 'react-intl';
import css from './index.module.scss';
import classNames from 'classnames';
import noImg from '../../assets/no-itm.png';
// const { selectFirstMenu } = Slices.menuSlice;
const { selectCurrentOrders } = Slices.orderSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDesktop } = Slices.appSlice;
export default function CurrentOrder(props) {
  const intl = useIntl();
  const allOrders = useSelector(selectCurrentOrders);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations && countryValidations.currency;
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const isDesktop = useSelector(selectDesktop);

  if (!auth.isLoggedIn) {
    return null;
  }

  // eslint:fix reOrder is defined but never used
  const handleNavigation = (id, status) => () => {
    if (status === 'PENDING') {
      navigate('/thank-you/' + id);
    } else {
      navigate('/track-order/' + id);
    }
  };

  let slicedOrders = [];

  if (props?.widgetData?.widgetType === 'HOME_TRACKORDER_BASIC') {
    slicedOrders = props?.orders.slice(0, 1);
  } else if (Array.isArray(allOrders)) {
    if (allOrders.length > 3) {
      slicedOrders = allOrders.slice(0, 3);
    } else {
      slicedOrders = allOrders;
    }
  }

  return (
    <section className={css.root}>
      {slicedOrders.map((item, i) => {
        let d =
          item?.advanceTime === 0
            ? new Date(item?.createdAt)
            : new Date(item?.advanceTime); /* midnight in China on April 13th */
        const abs = d
          .toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
          .split(',');

        const formDate = `${d.getDate()} ${d.toLocaleDateString('en-US', {
          month: 'long',
        })}, ${d.getFullYear()} | ${abs[1]}`;

        const imgSrc = item?.assets[0]?.src;
        const orderQty = item?.itemIds.length || item?.itemIdAndTypeIds?.length || 1;
        return (
          <div className={css.main} key={i}>
            <div className={css.order}>
              <div className={css.orderMain} onClick={handleNavigation(item._id, item.status)}>
                {!isDesktop && (
                  <div className={css.itmImg}>
                    <img
                      src={`${imgSrc}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImg;
                      }}
                      alt=""
                    />
                    <div className={css.itemStyle}>
                      <p>
                        {orderQty}
                        &nbsp;
                        {orderQty > 1 ? (
                          <FormattedMessage id="checkout_items" defaultMessage="Items" />
                        ) : (
                          <FormattedMessage id="checkout_item" defaultMessage="Item" />
                        )}
                      </p>
                    </div>
                  </div>
                )}
                <Grid className={css.textBackground}>
                  {item?.status !== 'PENDING' || item?.advanceTime > 0 ? (
                    <>
                      <div className={css.orderBox}>
                        <>
                          {item?.orderDisplayNumber ? (
                            <h5 className={css.orbNumber}>
                              <FormattedMessage
                                id={'orderdetails_orderno'}
                                defaultMessage="Order No"
                              />{' '}
                              <span className={css.redText}>{item?.orderDisplayNumber}</span>
                            </h5>
                          ) : null}
                        </>
                      </div>
                      <p className={css.orderDateBox}>
                        {item?.createdAt && format(item?.createdAt, 'dd LLL, yyyy')}
                      </p>
                      <p className={css.itemDescription}>{item?.name}</p>
                    </>
                  ) : (
                    <>
                      <strong>
                        <FormattedMessage
                          id="pendingConfirmation"
                          defaultMessage="Pending Confirmation"
                        />
                      </strong>

                      <p className={css.itemDescription}>{item?.name}</p>
                    </>
                  )}
                </Grid>
                {/* <div className={css.textBackground}>
                  
                  <p className={css.itemDescription}>{item?.name}</p>
                </div> */}
              </div>
              {isDesktop && (
                <div className={css.itemWrapper}>
                  <div className={css.itemDetails}>
                    <span className={css.orderCount}>
                      {orderQty}
                      &nbsp;
                      {orderQty > 1 ? (
                        <FormattedMessage id="checkout_items" defaultMessage="Items" />
                      ) : (
                        <FormattedMessage id="checkout_item" defaultMessage="Item" />
                      )}
                    </span>

                    <span>
                      <Typography
                        className={classNames(
                          { [css.warningColor]: item?.status === 'PENDING' },
                          { [css.orderStatus]: item?.status !== 'PENDING' },
                          { [css.futureOrder]: item?.advanceTime > 0 }
                        )}
                      >
                        {item?.advanceTime > 0
                          ? `${item?.address?.addressSubType} ${intl.formatMessage({
                              id: 'scheduled_for',
                            })} ${format(item?.advanceTime, 'dd LLL')} | ${format(
                              item?.advanceTime,
                              'hh:mm a'
                            )}`
                          : item?.status}
                      </Typography>
                    </span>
                  </div>
                </div>
              )}
              <div className={css.bottomSec}>
                <div className={css.amount}>
                  {decimalChecker(item.payment.amount)} {currency}
                </div>

                <div className={css.button}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleNavigation(item._id, item.status)}
                  >
                    <FormattedMessage id="navigation_trackOrder" defaultMessage="Track Order" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}
